import { render, staticRenderFns } from "./TrackingScans.vue?vue&type=template&id=055c0314"
import script from "./TrackingScans.vue?vue&type=script&lang=ts"
export * from "./TrackingScans.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports